import { createSelector } from 'reselect';
import { getFAIEnabled } from './getFAIEnabled';
import { getFAIState } from './getFAIState';

const getFAILoading = createSelector(
  [getFAIEnabled, getFAIState],
  (faiEnabled, fai) => {
    return faiEnabled && !fai?.initialized;
  }
);

export { getFAILoading };
